import { polyLineOverAtom, shippingCardOverAtom } from '@/commons/constants';
import { ShippingDetail } from '@/types/result';
import { useAtomValue } from 'jotai';
import { Marker } from 'react-naver-maps';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useState } from 'react';
export default function StartEndMarker({ list }: { list: ShippingDetail[] }) {
  const polyLineOver = useAtomValue(polyLineOverAtom);
  const shippingCardOver = useAtomValue(shippingCardOverAtom);
  const [highlightList, setHilightList] = useState<number[]>([]);

  useEffect(() => {
    //활성화(highlight) 대상 선정
    const temp: number[] = [];
    polyLineOver && temp.push(polyLineOver); //경로에 마우스 오버
    shippingCardOver && temp.push(shippingCardOver); //목록 마우스 오버
    setHilightList(temp);
  }, [polyLineOver, shippingCardOver]);

  return (
    <>
      {list &&
        list.map((slItem: ShippingDetail, slIndex: number) => {
          const check =
            highlightList.length > 0 && highlightList.findIndex((fItem) => fItem === slItem?.car.car_seq) > -1;
          return (
            <>
              {slItem?.route?.length > 0 && (
                <Marker
                  key={'S_' + slIndex}
                  zIndex={slIndex + (check ? 100 : 0)}
                  icon={{
                    content: `<div style='display:flex;opacity:${highlightList.length == 0 || check ? 1 : 0.4};width:1rem;height:1rem;justify-content:center;align-items:center;border-radius:25px;padding:0.25rem;background:${slItem?.color};color:#ffffff'>S${slItem?.reverse?.length > 0 ? '/E' : ''}</div>`,
                  }}
                  position={slItem?.route[0]}
                />
              )}
              {slItem.car.end_info.end_type !== 0 && slItem?.route?.length > 0 && (
                <Marker
                  key={'E_' + slIndex}
                  zIndex={slIndex}
                  icon={{
                    content: `<div style='display:flex;opacity:${highlightList.length == 0 || check ? 1 : 0.4};width:1rem;height:1rem;justify-content:center;align-items:center;border-radius:25px;padding:0.25rem;background:${slItem?.color};color:#ffffff'>E</div>`,
                  }}
                  position={slItem?.route[slItem.route.length - 1]}
                />
              )}
            </>
          );
        })}
    </>
  );
}
